<template>
  <el-container class="tui-content" style="display: block;">
    <el-row style="margin-top: 5%;margin-left: 5%;">
      <el-input v-model="name" placeholder="请输入搜索内容" style="width: 30%;"></el-input>
      <el-button type="primary" @click='loadData()'>搜索</el-button>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 5%;">
      <template>
        <el-table
      	:data="list"
        height="1500"
      	border
      	style="width: 910px;margin-left: 0;height: 800px;text-align: center;">

        <el-table-column

          width="200"
          label="分词内容"
           >
           <template slot-scope="scope">
               <div @click="dischange(scope.row.name,scope.row.id,scope.row.wn)">{{scope.row.name}}</div>


           </template>
        </el-table-column>
      	<el-table-column

          width="400"
      	  label="功能名称"
      	   >
           <template slot-scope="scope">
               <div style="text-align: center;">{{scope.row.gn}}</div>

           </template>
      	</el-table-column>

        <el-table-column

          width="200"
          label="所属位置"

           >
           <template slot-scope="scope">
               <div style="text-align: center;">{{scope.row.wn}}</div>
           </template>
        </el-table-column>
        <el-table-column

          width="100"
          label="操作"
           >
           <template slot-scope="scope">
             <el-row>
               <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id,scope.row.wn)">删除</el-col>

             </el-row>
           </template>
        </el-table-column>

        </el-table>
      </template>

    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
        list:[],
        name:'',
        dialogVisible:false,
        disDialogVisible:false,
        disName:'',
        stype:'',
        t:'',
        disId:0,
        delId:0

      }
    },
  	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }

    },

  	methods:{
      dischange(name,id,t){
        this.t = t;
        this.disId = id
        this.disName = name
        this.disDialogVisible = true
      },
      dodisChange(){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });
        axiosInstance({
        	method:'post',
        	params:{
            id:this.disId,
            name:this.disName,
            t:this.t
        	},
        	url:'http://y31p.yoooooo.com/index.php/index/data/searchChange'
        })
        .then(res=>{

          if(res.data.code == 200){
            this.disDialogVisible = false
            this.t = ''
            this.disId = 0
            this.disName = ''
            this.loadData()
            this.$message({
            	type: 'success',
            	message: '操作成功'
            });
          }



        })
        .catch(err=>{

        });
      },
      del(id,t){
        this.delId = id
        this.t = t
        this.dialogVisible = true
      },
        doDell(){
          const axiosInstance = this.$axios.create({
          	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
          	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
          });

          if(this.delId == ''){
             return false
          }
          axiosInstance({
          	method:'post',
          	params:{
          		id:this.delId,
              t:this.t
          	},
          	url:'http://y31p.yoooooo.com/index.php/index/data/searchDell'
          })
          .then(res=>{
          	if(res.data.code == 200){
               this.delId = 0
               this.t = ''
               this.dialogVisible = false
               this.loadData()
               this.$message({
               	type: 'success',
               	message: '操作成功'
               });

          	}else{
               this.dialogVisible = false
          	}

          })
          .catch(err=>{

          });
        },
        loadData(){
          const axiosInstance = this.$axios.create({
            headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
            withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
          });
          axiosInstance({
            method:'get',
            params:{
              name:this.name
            },
            url:'http://y31p.yoooooo.com/index.php/index/data/searchList'
          })
          .then(res=>{
            this.list = res.data;
            this.value = this.list[0]['value']

          })
          .catch(err=>{

          });
        },


        msg(msg,type){
          this.$message({
            message: msg,
            type: type
          });
        },

  	}


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/seach.vue